<div *ngIf="customers && customers.length > 0">
  <div>
    <div style="margin-left: 80%; margin-bottom: 2%; margin-top: 3%">
      <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary" [useExistingCss]="true"
        printSectionId="print-section" ngxPrint>
        Print
      </button>
      <button *ngIf="!viewmode" class="noPrint" style="margin-top: 2%; margin-left: 2%" [disabled]="saving"
        (click)="save()" mat-raised-button color="primary">
        Save
      </button>

      <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
        Close
      </button>
    </div>
  </div>

  <!-- Loop through each customer for multiple invoices -->
  <div id="print-section">
    <div class="container" *ngFor="let customer of customers; let cIndex = index">

      <!-- Header Section -->
      <div class="row" style="border-bottom: 2px solid #000;">
        <div class="col-9 topheader right">
          <span class="fontBold">हिंदुस्थान प्रकाशन संस्था</span>
          <span>
            <span class="heading1">प्रशासकीय कार्यालय</span> -
          </span>
          <span>
            116-119, पहिला मजला, शिल्पीन सेंटर, 40, गं. द. आंबेकर मार्ग, वडाला मुंबई - 400031
          </span>
          <span>
            दूरध्वनी: ९९६७५७०५३१, Email: vivekbookdept&#64;gmail.com
          </span>
        </div>
        <div class="col-3 flex">
          <img src="../../../assets/img/brand/red.png" alt="Logo" class="logo-img" />
        </div>
      </div>

      <!-- Tax Invoice Heading -->
      <div class="row taxheading bottom">
        <div class="fontBold">
          Tax Invoice / पुस्तक / ग्रंथ विक्री देयक
        </div>
      </div>

      <!-- GSTIN & PAN -->
      <div class="row bottom">
        <div class="col-6 right">
          <span style="font-weight: bold;">GSTIN/Unique Id : 27AAATH0433Q1ZI</span>
        </div>
        <div class="col-6">
          <span style="font-weight: bold;">PAN No. : AAATH0433Q</span>
        </div>
      </div>

      <!-- Invoice No & Date -->
      <div class="row bottom">
        <div class="col-6 right">
          <span style="font-weight: bold;">
            <b>Invoice No.</b> : {{ customer.generatedBillNo }}
          </span>
        </div>
        <div class="col-6">
          <span style="font-weight: bold;">
            <b>Date</b> : {{ date }}
          </span>
        </div>
      </div>

      <!-- Receiver & Consignee Details -->
      <div class="row bottom">
        <div class="col-6 right">
          <h3 style="font-weight: bold; margin: 5px 0;">Details of Receiver :</h3>
          <div class="receiver">Name : <strong>{{ customer.name }}</strong></div>
          <div class="receiver">Address : {{ customer.invoiceData?.rep_address }}</div>
          <div class="receiver">Phone : {{ customer.invoiceData?.rep_mobile }}</div>
          <div class="receiver">GSTIN : {{ customer.invoiceData?.gstNumber }}</div>
        </div>
        <div class="col-6">
          <h3 style="font-weight: bold; margin: 5px 0;">Details of Consignee :</h3>
          <div class="receiver">Name :</div>
          <div class="receiver">Address :</div>
          <div class="receiver">Phone :</div>
          <div class="receiver">GSTIN :</div>
        </div>
      </div>

      <!-- Book Table Header -->
      <div class="row">
        <div class="col-1 tableDescheader" style="border-bottom: 2px solid #000; border-right: 2px solid #000;">S.No
        </div>
        <div class="col-3 tableDescheader" style="border-bottom: 2px solid #000; border-right: 2px solid #000;">Book
          Name</div>
        <div class="col-1 tableDescheader" style="border-bottom: 2px solid #000; border-right: 2px solid #000;">HSN Code
        </div>
        <div class="col-1 tableDescheader" style="border-bottom: 2px solid #000; border-right: 2px solid #000;">Book
          Price</div>
        <div class="col-1 tableDescheader" style="border-bottom: 2px solid #000; border-right: 2px solid #000;">Book
          Sale<br>Price</div>
        <div class="col-1 tableDescheader" style="border-bottom: 2px solid #000; border-right: 2px solid #000;">Discount
          Amount</div>
        <div class="col-1 tableDescheader" style="border-bottom: 2px solid #000; border-right: 2px solid #000;">Net
          Amount</div>
        <div class="col-1 tableDescheader" style="border-bottom: 2px solid #000; border-right: 2px solid #000;">Book
          Copies</div>
        <div class="col-2 tableDescheader" style="border-bottom: 2px solid #000;">Total Taxable<br>Value</div>
      </div>

      <!-- Book Table Rows -->
      <div class="row" *ngFor="let item of customer.book_data; let i = index">
        <div class="col-1 tableDesc"
          style="border-bottom: 2px solid #000; border-right: 2px solid #000; text-align: center;">
          {{ i + 1 }}
        </div>
        <div class="col-3 tableDesc"
          style="border-bottom: 2px solid #000; border-right: 2px solid #000; text-align: left;">
          {{ item["bookname"] }}
        </div>
        <div class="col-1 tableDesc"
          style="border-bottom: 2px solid #000; border-right: 2px solid #000; text-align: right;">
          4902
        </div>
        <div class="col-1 tableDesc"
          style="border-bottom: 2px solid #000; border-right: 2px solid #000; text-align: right;">
          {{ item["bookprice"] }}
        </div>
        <div class="col-1 tableDesc"
          style="border-bottom: 2px solid #000; border-right: 2px solid #000; text-align: right;">
          <span *ngIf="item['discount'] > 0">0</span>
          <span *ngIf="item['discount'] == 0">{{ item["booksaleprice"] }}</span>
        </div>
        <div class="col-1 tableDesc"
          style="border-bottom: 2px solid #000; border-right: 2px solid #000; text-align: right;">
          {{ item["discountamt"] || 0 }}
        </div>
        <div class="col-1 tableDesc"
          style="border-bottom: 2px solid #000; border-right: 2px solid #000; text-align: right;">
          {{ item["totalafterdiscount"] }}
        </div>
        <div class="col-1 tableDesc"
          style="border-bottom: 2px solid #000; border-right: 2px solid #000; text-align: right;">
          {{ item["bookcopies"] }}
        </div>
        <div class="col-2 tableDesc" style="border-bottom: 2px solid #000; text-align: right;">
          {{ item["total"] }}
        </div>
      </div>

      <!-- Total Row -->
      <div class="row" style="font-weight: 500; background: white; border-bottom: 2px solid #000;">
        <div class="col-9 tableDesc right" style="text-align: right; padding-right: 10px;">
          Total
        </div>
        <div class="col-1 tableDesc right" style="text-align: right;">
          {{ customer.book_copies_total }}
        </div>
        <div class="col-2 tableDesc" style="text-align: right;">
          {{ customer.total_total }}
        </div>
      </div>

      <!-- Amount in Words & GST Section -->
      <!-- <div class="row">
        <div class="col-8 right bottom heading1" style="font-weight: 500; border-bottom: none;">
          <b>Invoice Total in Words:</b> {{ customer.amtinwords }}
        </div>
        <div class="col-4 bottom spacebet">
          <span>GST% :</span>
          <span>{{ customer.invoiceData?.percent || 0 }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-8 right bottom" style="border-bottom: none;"></div>
        <div class="col-4 bottom spacebet">
          <span>CGST</span>
          <span>{{ customer.invoiceData?.CGST || 0 }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-8 right bottom" style="border-bottom: none;"></div>
        <div class="col-4 bottom spacebet">
          <span>SGST</span>
          <span>{{ customer.invoiceData?.SGST || 0 }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-8 right bottom" style="border-bottom: none;"></div>
        <div class="col-4 bottom spacebet">
          <span>IGST</span>
          <span style="font-weight: 500;">{{ customer.invoiceData?.IGST || 0 }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-8 right " style=""></div>
        <div class="col-4  spacebet">
          <span>TOTAL GST</span>
          <span>{{ customer.invoiceData?.TOTAL_GST || 0 }}</span>
        </div>
      </div> -->
  <div class="row noborderRow">

      <div class="col-8 heading1"style="border-bottom: 2px solid black;">
        <strong>Invoice Total in Words:</strong> {{ customer.amtinwords }}
      </div>

      <div class="col-4">
        <table style="width: 100%; border-collapse: collapse; text-align: center;">
          <tr>
            <th>SGST</th><th>CGST</th><th>IGST</th><th>Total GST</th>
          </tr>
          <tr>
            <td>{{ customer.invoiceData?.SGST_percent }}%</td>
            <td>{{ customer.invoiceData?.CGST_percent }}%</td>
            <td>{{ customer.invoiceData?.IGST_percent   }}%</td>
            <td><strong>{{ customer.invoiceData?.percent }}%</strong></td>
          </tr>
          <tr>
            <td>{{ customer.invoiceData?.SGST }}</td>
            <td>{{ customer.invoiceData?.CGST }}</td>
            <td>{{ customer.invoiceData?.IGST }}</td>
            <td><strong>{{ customer.invoiceData?.TOTAL_GST  }}</strong></td>
          </tr>
        </table>
      </div>
    </div>
      <!-- Bank Details & Summary -->
      <div class="row details">
        <!-- LEFT SIDE: Bank Details + QR Code -->
        <div class="col-8" style="
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      padding-bottom: 10px;
      border-right: 2px solid #000;
      padding: 10px;
    ">
          <!-- Bank Details -->
          <div style="display: flex; flex-direction: column; gap: 5px;">
            <div style="font-weight: 500;">Bank Details -</div>
            <div>A/C Name - HINDUSTAN PRAKASHAN SANSTHA</div>
            <div>A/C No. - 20109800154</div>
            <div>IFSC No. - MAHB0000318</div>
            <div>Bank Name - Bank of Maharashtra</div>
            <div>Bank Branch - Prabhadevi, Mumbai - 400025</div>
          </div>

          <!-- QR Code -->
          <div style="display: flex; justify-content: center; align-items: center;">
            <img src="../../../assets/img/brand/qr_code1.png" alt="QR Code" class="qr-code" />
          </div>
        </div>

        <!-- RIGHT SIDE: Totals -->
        <div class="col-4" style="
      display: flex;
      flex-direction: column;
      gap: 6px;
      padding:0px !important;
      justify-content: space-between;
    ">
          <div class="spacebet">
            <span>Total :</span>
            <span>{{ (customer.total_total || 0) + (+customer.invoiceData?.TOTAL_GST || 0) }}</span>
          </div>

          <div class="spacebet">
            <span>Shipping Charges :</span>
            <span>{{ customer.shipping_charges_total }}</span>
          </div>

          <div class="spacebet">
            <span>Round Off :</span>
            <span>0</span>
          </div>

          <div class="spacebet">
            <span>Invoice Total :</span>
            <span style="font-weight: 500;">
              {{
              (customer.total_total || 0) +
              (+customer.invoiceData?.TOTAL_GST || 0) +
              (customer.shipping_charges_total || 0)
              }}
            </span>
          </div>

          <!-- <div class="spacebet">
            <span>Previous Deposit :</span>
            <span>0</span>
          </div> -->

          <div class="spacebet">
            <span>Previous Dues :</span>
            <span>0</span>
          </div>

          <div class="spacebet">
            <span>Total Dues :</span>
            <span>
              {{
              (customer.total_total || 0) +
              (+customer.invoiceData?.TOTAL_GST || 0) +
              (customer.shipping_charges_total || 0)
              }}
            </span>
          </div>
        </div>
      </div>


      <!-- Terms & Signature -->
      <div class="row">
        <div class="col-8 right flexbox" style="padding: 15px;">
          <h2 style="font-weight: bold; margin: 0 0 10px 0;">Terms:</h2>
          <span>
            1) Complaints of any nature must be communicated in writing within 10 Days from the date of delivery.
          </span>
          <span>2) A/C payee cheques to be drawn in favor of :-</span>
          <span style="font-weight: 500;">हिंदुस्थान प्रकाशन संस्था - पुस्तक विभाग</span>
        </div>

        <div class="col-4 flexadd" style="padding: 15px;">
          <span style="font-size: 1.2rem; display: block; font-weight: 700;">
            हिंदुस्थान प्रकाशन संस्था
          </span>
          <div style="height: 80px;"></div>
          <div style="text-align: center; padding-top: 5px;">
            <span style="font-weight: 500;">Authorised Signatory</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>